import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { isLogin } from '@/utils/auth'

Vue.use(VueRouter)

// 屏蔽重复跳转同一路由时抛出的 NavigationDuplicated 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure && VueRouter.isNavigationFailure(err)) return err
    if (err && err.name === 'NavigationDuplicated') return err
    return Promise.reject(err)
  })
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure && VueRouter.isNavigationFailure(err)) return err
    if (err && err.name === 'NavigationDuplicated') return err
    return Promise.reject(err)
  })
}

// 需要登录才能访问的页面
const AUTH_REQUIRED_PATHS = [
  '/user', '/cost-apply', '/add-sample', '/edit-sample',
  '/add-standard', '/add-team', '/edit-team', '/manage-team',
  '/cancel-apply', '/customer-list'
]

const routes = [
  // ========== 首页 ==========
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/home/Index.vue'),
    meta: { title: '首页', act: 'index' }
  },

  // ========== 认证相关 ==========
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { title: '登录', act: 'login' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
    meta: { title: '注册', act: 'register' }
  },
  {
    path: '/find-password',
    name: 'FindPassword',
    component: () => import('@/views/auth/FindPassword.vue'),
    meta: { title: '找回密码', act: 'findPassword' }
  },

  // ========== 检测平台 ==========
  {
    path: '/jcpt',
    name: 'Jcpt',
    component: () => import('@/views/platform/Jcpt.vue'),
    meta: { title: '检测平台', act: 'jcpt' }
  },
  {
    path: '/jcpt-yqjs',
    name: 'JcptYqjs',
    component: () => import('@/views/platform/JcptYqjs.vue'),
    meta: { title: '仪器介绍', act: 'jcpt' }
  },

  // ========== 仪器预约 ==========
  {
    path: '/yqyy',
    name: 'Yqyy',
    component: () => import('@/views/instrument/Yqyy.vue'),
    meta: { title: '仪器预约', act: 'yqyy' }
  },
  {
    path: '/jsyy',
    name: 'Jsyy',
    component: () => import('@/views/instrument/Jsyy.vue'),
    meta: { title: '机时预约', act: 'yqyy', requireAuth: true }
  },
  {
    path: '/jsyy-xz',
    name: 'JsyyXz',
    component: () => import('@/views/instrument/JsyyXz.vue'),
    meta: { title: '机时预约下载', act: 'yqyy', requireAuth: true }
  },
  {
    path: '/jsdj',
    name: 'Jsdj',
    component: () => import('@/views/instrument/Jsdj.vue'),
    meta: { title: '机时登记', act: 'yqyy', requireAuth: true }
  },
  {
    path: '/jsxq',
    name: 'Jsxq',
    component: () => import('@/views/instrument/Jsxq.vue'),
    meta: { title: '机时详情', act: 'yqyy' }
  },

  // ========== 委托检测 ==========
  {
    path: '/wtjc',
    name: 'Wtjc',
    component: () => import('@/views/entrust/Wtjc.vue'),
    meta: { title: '委托检测', act: 'wtjc' }
  },
  {
    path: '/wtjc-detail',
    name: 'WtjcDetail',
    component: () => import('@/views/entrust/WtjcDetail.vue'),
    meta: { title: '委托详情', act: 'wtjc', noResponsive: true }
  },
  {
    path: '/wtjc-edit',
    name: 'WtjcEdit',
    component: () => import('@/views/entrust/WtjcEdit.vue'),
    meta: { title: '委托编辑', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/wtjc-xq',
    name: 'WtjcXq',
    component: () => import('@/views/entrust/WtjcXq.vue'),
    meta: { title: '委托详情', act: 'wtjc', noResponsive: true }
  },
  {
    path: '/entrust-view',
    name: 'EntrustView',
    component: () => import('@/views/entrust/EntrustView.vue'),
    meta: { title: '委托查看', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: () => import('@/views/entrust/Apply.vue'),
    meta: { title: '委托申请', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/cancel-apply',
    name: 'CancelApply',
    component: () => import('@/views/entrust/CancelApply.vue'),
    meta: { title: '取消申请', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/progress-query',
    name: 'ProgressQuery',
    component: () => import('@/views/entrust/ProgressQuery.vue'),
    meta: { title: '进度查询', act: 'wtjc' }
  },

  // ========== 新闻中心 ==========
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/news/NewsList.vue'),
    meta: { title: '新闻中心', act: 'news' }
  },
  {
    path: '/news-detail',
    name: 'NewsDetail',
    component: () => import('@/views/news/NewsDetail.vue'),
    meta: { title: '新闻详情', act: 'news' }
  },
  {
    path: '/tzgg',
    name: 'Tzgg',
    component: () => import('@/views/news/Tzgg.vue'),
    meta: { title: '通知公告', act: 'news' }
  },
  {
    path: '/pxtz',
    name: 'Pxtz',
    component: () => import('@/views/train/Pxtz.vue'),
    meta: { title: '培训通知', act: 'news' }
  },
  {
    path: '/train-detail',
    name: 'TrainDetail',
    component: () => import('@/views/train/TrainDetail.vue'),
    meta: { title: '培训详情', act: 'news' }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/news/Search.vue'),
    meta: { title: '搜索', act: 'news' }
  },

  // ========== 机构概况 ==========
  {
    path: '/zxjj',
    name: 'Zxjj',
    component: () => import('@/views/about/Zxjj.vue'),
    meta: { title: '中心简介', act: 'zxjj' }
  },
  {
    path: '/zxjg',
    name: 'Zxjg',
    component: () => import('@/views/about/Zxjg.vue'),
    meta: { title: '中心架构', act: 'zxjj' }
  },
  {
    path: '/zxzz',
    name: 'Zxzz',
    component: () => import('@/views/about/Zxzz.vue'),
    meta: { title: '中心资质', act: 'zxjj' }
  },
  {
    path: '/zxcy',
    name: 'Zxcy',
    component: () => import('@/views/about/Zxcy.vue'),
    meta: { title: '中心成员', act: 'zxjj' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about/About.vue'),
    meta: { title: '关于我们', act: 'about' }
  },

  // ========== 意见反馈 ==========
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('@/views/feedback/Feedback.vue'),
    meta: { title: '意见反馈', act: 'feedback' }
  },
  {
    path: '/comment',
    name: 'Comment',
    component: () => import('@/views/feedback/Comment.vue'),
    meta: { title: '留言', act: 'feedback' }
  },

  // ========== 信息公开 ==========
  {
    path: '/xxgk',
    name: 'Xxgk',
    component: () => import('@/views/info/Xxgk.vue'),
    meta: { title: '信息公开', act: 'xxgk' }
  },
  {
    path: '/gzzd',
    name: 'Gzzd',
    component: () => import('@/views/info/Gzzd.vue'),
    meta: { title: '规章制度', act: 'xxgk' }
  },
  {
    path: '/wjxz',
    name: 'Wjxz',
    component: () => import('@/views/info/Wjxz.vue'),
    meta: { title: '文件下载', act: 'xxgk' }
  },
  {
    path: '/elements-table',
    name: 'ElementsTable',
    component: () => import('@/views/info/ElementsTable.vue'),
    meta: { title: '元素表', act: 'xxgk' }
  },
  {
    path: '/hx-elements',
    name: 'HXelements',
    component: () => import('@/views/info/HXelements.vue'),
    meta: { title: '化学元素表', act: 'xxgk' }
  },

  // ========== 用户中心 ==========
  {
    path: '/user',
    name: 'UserCenter',
    component: () => import('@/views/user/UserCenter.vue'),
    meta: { title: '用户中心', act: 'grzx', requireAuth: true },
    children: [
      {
        path: 'grxx',
        name: 'Grxx',
        component: () => import('@/views/user/Grxx.vue'),
        meta: { title: '个人信息', act: 'grzx', requireAuth: true }
      },
      {
        path: 'xxtz',
        name: 'Xxtz',
        component: () => import('@/views/user/Xxtz.vue'),
        meta: { title: '消息通知', act: 'grzx', requireAuth: true }
      },
      {
        path: 'wdyy',
        name: 'Wdyy',
        component: () => import('@/views/user/Wdyy.vue'),
        meta: { title: '我的预约', act: 'grzx', requireAuth: true }
      },
      {
        path: 'mmxg',
        name: 'Mmxg',
        component: () => import('@/views/user/Mmxg.vue'),
        meta: { title: '密码修改', act: 'grzx', requireAuth: true }
      },
      {
        path: 'wtbg',
        name: 'Wtbg',
        component: () => import('@/views/user/Wtbg.vue'),
        meta: { title: '委托报告', act: 'grzx', requireAuth: true }
      },
      {
        path: 'wdfy',
        name: 'Wdfy',
        component: () => import('@/views/user/Wdfy.vue'),
        meta: { title: '我的费用', act: 'grzx', requireAuth: true }
      },
      {
        path: 'wdwt',
        name: 'Wdwt',
        component: () => import('@/views/user/Wdwt.vue'),
        meta: { title: '我的委托', act: 'grzx', requireAuth: true }
      },
      {
        path: 'wtqr',
        name: 'Wtqr',
        component: () => import('@/views/user/Wtqr.vue'),
        meta: { title: '委托确认', act: 'grzx', requireAuth: true }
      },
      {
        path: 'sjxz',
        name: 'Sjxz',
        component: () => import('@/views/user/Sjxz.vue'),
        meta: { title: '数据下载', act: 'grzx', requireAuth: true }
      },
      {
        path: 'jdcx',
        name: 'Jdcx',
        component: () => import('@/views/user/Jdcx.vue'),
        meta: { title: '进度查询', act: 'grzx', requireAuth: true }
      },
      {
        path: 'ktz',
        name: 'Ktz',
        component: () => import('@/views/user/Ktz.vue'),
        meta: { title: '开通账号', act: 'grzx', requireAuth: true }
      },
      {
        path: 'apply-detail',
        name: 'ApplyDetail',
        component: () => import('@/views/user/ApplyDetail.vue'),
        meta: { title: '申请详情', act: 'grzx', requireAuth: true }
      }
    ]
  },

  // ========== 其他独立页面 ==========
  {
    path: '/cost-apply',
    name: 'CostApply',
    component: () => import('@/views/entrust/CostApply.vue'),
    meta: { title: '费用申请', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/add-sample',
    name: 'AddSample',
    component: () => import('@/views/entrust/AddSample.vue'),
    meta: { title: '添加样品', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/edit-sample',
    name: 'EditSample',
    component: () => import('@/views/entrust/EditSample.vue'),
    meta: { title: '编辑样品', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/add-standard',
    name: 'AddStandard',
    component: () => import('@/views/entrust/AddStandard.vue'),
    meta: { title: '添加标准', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/add-team',
    name: 'AddTeam',
    component: () => import('@/views/entrust/AddTeam.vue'),
    meta: { title: '添加团队', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/edit-team',
    name: 'EditTeam',
    component: () => import('@/views/entrust/EditTeam.vue'),
    meta: { title: '编辑团队', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/manage-team',
    name: 'ManageTeam',
    component: () => import('@/views/entrust/ManageTeam.vue'),
    meta: { title: '管理团队', act: 'wtjc', requireAuth: true, noResponsive: true }
  },
  {
    path: '/customer-list',
    name: 'CustomerList',
    component: () => import('@/views/entrust/CustomerList.vue'),
    meta: { title: '客户列表', act: 'wtjc', requireAuth: true, noResponsive: true }
  },

  // ========== 404 ==========
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/home/Index.vue'),
    meta: { title: '首页' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 路由切换时滚动到顶部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫：需要登录的页面跳转到登录页
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' - 广东腐蚀科学与技术创新研究院'
  }

  // 检查是否需要登录
  if (to.meta && to.meta.requireAuth) {
    if (!isLogin()) {
      // 保存当前目标页面路径，登录后返回
      sessionStorage.setItem('returnUrl', to.fullPath)
      // 弹窗提示未登录（不强制跳转）
      store.commit('SET_LOGIN_TIP', true)
      // 阻止进入需登录页：有来源页则留在原页，否则回首页
      if (from && from.name) {
        next(false)
      } else {
        next({ path: '/' })
      }
      return
    }
  }

  next()
})

export default router
